<template>
  <div v-loading="listContentLoading">
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      clearable
      placeholder="打卡标题"
    ></el-input>
    <el-date-picker
        class="search-el"
        size="small"
        v-model="query.start_end_at"
        value-format='yyyy-MM-dd HH:mm:ss'
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
    </el-date-picker>
    <el-select
        class="search-el"
        size="mini"
        v-model="query.status"
        placeholder="请选择状态"
        clearable
        filterable
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="未开始" value="1">未开始</el-option>
      <el-option label="进行中" value="2">进行中</el-option>
      <el-option label="已结束" value="3">已结束</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getAttendanceList()">
      查询</el-button
    >
    <el-button type="primary" size="mini" @click="goToDetails(0)">
      添加打卡</el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
            prop="title"
            label="打卡标题"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="start_end_date"
          label="起止日期"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
            prop="yet_total_days"
            label="已进行/总天数"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column
            prop="clock_nums_times"
            label="打卡人数/次数"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column label="返现人数" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="small"
                @click="goToRefundList(row.id)"
            >
              <div>{{ row.refund_user_nums }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
            prop="course_title"
            label="关联课程"
            align="center"
            min-width="15%"
        >
          <template slot-scope="{ row }">
            <span>{{row.course_title}}【{{row.course_id}}】</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="course_title"
            label="课程封面"
            align="center"
            min-width="15%"
        >
          <template slot-scope="{ row }">
            <el-image style="height: 80%;width: 80%;" :src="row.img_url"></el-image>
          </template>
        </el-table-column>

        <el-table-column
            prop="course_title"
            label="课程二维码"
            align="center"
            min-width="15%"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="viewURL(row.course_id)">
              点击查看二维码
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
            prop="status"
            label="状态"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column label="" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="small"
                @click="goToDetails(row.id)"
            >
              <div>详情</div>
            </el-button>
          </template>
        </el-table-column>

<!--        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              size="mini"
              @click="deleteChannelItem(row.id)"
            >
              删除
            </el-button>

            <el-button size="mini" @click="toChannelItemData(row.channel_id, row.id)">
              数据
            </el-button>
          </template>
        </el-table-column>-->
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getAttendanceList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
    <!-- 二维码弹窗 -->
    <el-dialog title="课程地址" :visible.sync="dialogVisible2" width="50%">
      <el-input
          v-model="liveURL"
          style="width: 66%; margin-left: 256 /2; position: relative; left: 10%;"
      ></el-input>
      <div
          id="qrcode"
          style="margin-left: 256 /2; position: relative; left: 10%;"
      ></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="copy(liveURL)">复制</el-button>
        <el-button
            type="primary"
            @click="
            dialogVisible2 = false;
            liveURL = '';
          "
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAttendanceList,
  getObjectQrcodeUrl
} from "@/api/clockIn";

import { qrCode, copyData} from "@/api/common";

export default {
  data: function () {
    return {
      dialogVisible: false,
      dialogVisible2:false,
      liveURL: "",
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        title: "",
        start_end_at: "",
        status: "",
      },
      statusList: [],
      attendanceList: [],

      listContentLoading: false,

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  created: function () {
    if (this.$route.query.channel_id != undefined) {
      this.query.channel_id = Number(this.$route.query.channel_id);
    }
    this.getAttendanceList();
    /*getAttendanceList(this.query).then((response) => {
      this.list = response.data.list;
      this.total = response.data.total;
      this.loading = false;
    });*/
  },
  methods: {
    toChannelItemData(channel_id, channel_item_id) {
        this.$router.push({
            path: "/channel/itemData",
            query: {
                channel_id: channel_id,
                channel_item_id: channel_item_id
            },
        });
      },

    filterChannel(channel_id) {      
      return this.attendanceList[channel_id.toString()];
    },


    goToDetails(id){

      this.$router.push({
        path: "/clockIn/info",
        query: {id:id}
      });
    },
    goToRefundList(id){
      this.$router.push({
        path: "/clockIn/studentCert",
        query: {attendance_id:id}
      });
    },

    getAttendanceList() {
      this.loading = true;
      getAttendanceList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    //获取二维码url
    viewURL(id) {
      getObjectQrcodeUrl({
        id: id,
      }).then((response) => {
        if (response.status == 2000) {
          this.dialogVisible2 = true;
          this.$nextTick(function () {
            document.getElementById("qrcode").innerHTML = "";
            this.liveURL = response.data.url;
            let qrcode = qrCode(response.data.url, 300, 300);
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    copy(url) {
      copyData(url);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },

    deleteChannelItem(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteChannelItem({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getAttendanceList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {
    
  },
};
</script>
